/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Createyouraccountwith3Inputs */

const en_auth_createyouraccountwith3 = /** @type {(inputs: Auth_Createyouraccountwith3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your account with OKTA`)
};

/**
* | output |
* | --- |
* | "Create your account with OKTA" |
*
* @param {Auth_Createyouraccountwith3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const auth_createyouraccountwith3 = /** @type {((inputs?: Auth_Createyouraccountwith3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Createyouraccountwith3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_createyouraccountwith3(inputs)
});
export { auth_createyouraccountwith3 as "auth_createYourAccountWith" }